import LandingReveal from '@/modules/Pages/shared/LandingReveal';

const contrastCards = [
  {
    label: 'Looks risky',
    outcome: 'Stays',
    accent: '#00d688',
    accentBg: 'rgba(0, 214, 136, 0.08)',
    border: 'rgba(0, 214, 136, 0.25)',
  },
  {
    label: 'Looks fine',
    outcome: 'Leaves',
    accent: '#ffbe00',
    accentBg: 'rgba(255, 190, 0, 0.08)',
    border: 'rgba(255, 190, 0, 0.25)',
  },
];

export default function RevenueParadoxSection() {
  return (
    <section className="py-24 px-6 bg-dark-gray-b border-t border-light">
      <div className="max-w-6xl mx-auto">
        <LandingReveal>
          <h2 className="landing-headline text-3xl md:text-4xl lg:text-[2.75rem] font-bold leading-tight mb-8 max-w-4xl">
            You&apos;re growing revenue. But churn keeps taking part of it back.
          </h2>
        </LandingReveal>

        <div className="grid lg:grid-cols-[1.1fr_0.9fr] gap-12 items-start">
          <LandingReveal delayClass="landing-delay-1" className="space-y-5 landing-prose">
            <p>You win new customers. ARR goes up.</p>
            <p>Then a customer you thought was healthy cancels before anyone realizes there&apos;s a problem.</p>
            <p className="text-primary font-medium">And the frustrating part?</p>
            <p>It isn&apos;t always the customers everyone was worried about.</p>
          </LandingReveal>

          <div className="grid sm:grid-cols-2 gap-4">
            {contrastCards.map((card, index) => (
              <LandingReveal key={card.label} delayClass={index === 0 ? 'landing-delay-1' : 'landing-delay-2'}>
                <div
                  className="landing-card p-6 h-full"
                  style={{ borderColor: card.border, backgroundColor: card.accentBg }}
                >
                  <p className="text-sm uppercase tracking-wider mb-2 text-secondary">The customer that</p>
                  <p className="text-2xl font-bold mb-4 font-secondary" style={{ color: card.accent }}>
                    {card.label}
                  </p>
                  <p className="text-3xl font-bold text-primary font-secondary">{card.outcome}</p>
                </div>
              </LandingReveal>
            ))}
          </div>
        </div>

        <LandingReveal delayClass="landing-delay-2" className="mt-14 max-w-3xl mx-auto text-center">
          <p className="landing-prose mb-4">And when that happens, you don&apos;t just lose the revenue.</p>
          <p className="text-xl md:text-2xl font-semibold text-primary font-secondary leading-relaxed">
            You lose the chance to do something before they make up their mind.
          </p>
        </LandingReveal>
      </div>
    </section>
  );
}
